import React from "react";
import BoostedAmount from "./BoostedAmount";
import OldAmount from "./OldAmount";
import { StyledFlex } from "./styled";
var BoostedSaving = function (_a) {
    var _b;
    var userSavings = _a.userSavings, boostedSavings = _a.boostedSavings, isFullPage = _a.isFullPage;
    return (React.createElement(StyledFlex, { isFullPage: isFullPage },
        React.createElement(BoostedAmount, { value: userSavings.value }),
        React.createElement(OldAmount, { value: (_b = boostedSavings === null || boostedSavings === void 0 ? void 0 : boostedSavings.oldSavings) === null || _b === void 0 ? void 0 : _b.value })));
};
export default BoostedSaving;
